import { ReferentialKey } from 'api/referential';
import { ComponentKey } from 'enums/componentKey';
import { InputsConfig } from 'types/form/inputsConfig';
import { IncomesFormFieldNames, TenantFormFieldNames } from '../types/tenantFormFieldNames';
import { TenantFormValues } from '../types/tenantFormValues';

export const tenantInputsConfig: InputsConfig<Exclude<keyof TenantFormValues, 'id'>> = {
  [TenantFormFieldNames.Civility]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.Civility,
    name: TenantFormFieldNames.Civility,
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.CIVILITY',
  },
  [TenantFormFieldNames.FirstName]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.FirstName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.FIRST_NAME',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.FIRST_NAME'
  },
  [TenantFormFieldNames.LastName]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.LastName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.LAST_NAME',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.LAST_NAME'
  },
  [TenantFormFieldNames.BirthDate]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.BirthDate,
    type: 'date',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.DATE_OF_BIRTH',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.DATE_OF_BIRTH'
  },
  [TenantFormFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.Phone,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.PHONE',
  },
  [TenantFormFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.Email,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.EMAIL',
  },
  [TenantFormFieldNames.Guarantor]: {
    componentKey: ComponentKey.Custom,
    name: TenantFormFieldNames.Guarantor,
  },
  [TenantFormFieldNames.ProfessionalSituation]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.EmploymentStatus,
    name: TenantFormFieldNames.ProfessionalSituation,
    required: true,
    label: 'TENANT.LABELS.PROFESSIONNAL_STATUS',
    placeholder: 'TENANT.PLACEHOLDERS.PROFESSIONNAL_STATUS',
  },
  [TenantFormFieldNames.CheckInDate]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.CheckInDate,
    type: 'date',
    required: true,
    label: 'TENANT.LABELS.CHECK_IN_DATE',
    placeholder: 'TENANT.PLACEHOLDERS.CHECK_IN_DATE'
  },
  [TenantFormFieldNames.CheckOutDate]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.CheckOutDate,
    type: 'date',
    required: false,
    label: 'TENANT.LABELS.CHECK_OUT_DATE',
    placeholder: 'TENANT.PLACEHOLDERS.CHECK_OUT_DATE'
  },
  [TenantFormFieldNames.RentPaymentsUpToDate]: {
    componentKey: ComponentKey.RadioGroup,
    name: TenantFormFieldNames.RentPaymentsUpToDate,
    required: true,
    label: 'TENANT.LABELS.RENT_PAYMENTS_UP_TO_DATE',
    options: [
      { value: true, label: 'COMMON.LABELS.YES' },
      { value: false, label: 'COMMON.LABELS.NO' },
    ],
    direction: 'horizontal',
  },
  [TenantFormFieldNames.Incomes]: {
    componentKey: ComponentKey.DynamicArray,
    name: TenantFormFieldNames.Incomes,
    required: false,
    gridCols: 6,
    fields: [
      {
        componentKey: ComponentKey.ReferentialDropdown,
        name: IncomesFormFieldNames.IncomeType,
        placeholder: "TENANT.LABELS.INCOME_TYPE",
        referentialKey: ReferentialKey.IncomeType,
        colSpan: 4,
        required: true
      },
      {
        componentKey: ComponentKey.InputWithUnit,
        name: IncomesFormFieldNames.Amount,
        type: 'number' as const,
        placeholder: 'COMMON.LABELS.AMOUNT',
        colSpan: 2,
        unit: '€',
        required: true
      },
    ],
    minItems: 0,
    emptyConfig: {
      title: 'TENANT.LABELS.EMPTY_INCOME_TITLE',
      description: 'TENANT.LABELS.EMPTY_INCOME_DESCRIPTION',
      iconKey: "receiptEuro"
    },
    addButtonText: 'TENANT.LABELS.ADD_INCOME',
    initialItem: {
      [IncomesFormFieldNames.IncomeType]: undefined,
      [IncomesFormFieldNames.Amount]: 0,
    }
  }
};
